import clsx from 'clsx';
import type { CSSProperties } from 'react';
import { memo } from 'react';

import { legendConfig } from '@utilities/standings';

import * as classes from './styles.module.scss';

const QualifiedIndicator = ({
  labelId,
  type,
  className,
}: {
  labelId?: string;
  type: 'bar' | 'dot';
  className?: string;
}) => {
  const colors = labelId && legendConfig.get(labelId);

  return (
    <div
      className={clsx(
        'pk-d--flex pk-flex--column',
        classes.qualified,
        classes[type],
        !!colors?.secondary && classes.double,
        className,
      )}
      style={
        {
          '--_qualified-color': !!colors?.primary && `var(--pk-${colors.primary})`,
          '--_qualified-color--secondary': !!colors?.secondary && `var(--pk-${colors.secondary})`,
        } as CSSProperties
      }
    />
  );
};

export default memo(QualifiedIndicator);
